import { useTranslation } from 'react-i18next'
import { useModalState } from '~/atoms/ModalState'
import { MangoAlert } from '~/components/shared/MangoAlert'
import { toaster } from '~/components/ui/toaster'
import { NotificationDisposition } from '~/services/EventEmitter/types/NotificationEmitterTypes'

const TOAST_LOGGED_IN_ID = 'CallQueue_LoggedIn'
const TOAST_LOGGED_OUT_ID = 'CallQueue_LoggedOut'
const TOAST_STATUS_UPDATED_ID = 'CallQueue_StatusUpdated'
export const useQueueAlerts = () => {
  const { t } = useTranslation()
  const {
    confirmModal: [, setConfirmModalState],
  } = useModalState()

  const showQueueUpdateErrorModal = () => {
    setConfirmModalState({
      title: t('queueToasts.unableToUpdateStatus'),
      message: t('queueToasts.queueUpdateErrorMessage'),
      confirmText: t('queueToasts.ok'),
      closeAfterConfirm: true,
      isDestructive: false,
      onConfirm: () => {},
    })
  }

  const showQueueUpdateGenericErrorModal = () => {
    setConfirmModalState({
      title: t('queueToasts.unableToUpdateStatus'),
      message: t('queueToasts.genericUpdateErrorMessage'),
      confirmText: t('queueToasts.ok'),
      closeAfterConfirm: true,
      isDestructive: false,
      onConfirm: () => {},
    })
  }

  const showLoggedInToast = () => {
    toaster.dismiss(TOAST_LOGGED_IN_ID)
    toaster.create({
      id: TOAST_LOGGED_IN_ID,
      duration: 4000,
      meta: {
        closable: true,
        customRender: () => (
          <MangoAlert
            title={t('queueToasts.loggedInToQueue')}
            status={NotificationDisposition.Success}
            closeOnClick
            onClose={() => {
              toaster.dismiss(TOAST_LOGGED_IN_ID)
            }}
          />
        ),
      },
    })
  }

  const showLoggedOutToast = () => {
    toaster.dismiss(TOAST_LOGGED_OUT_ID)
    toaster.create({
      id: TOAST_LOGGED_OUT_ID,
      duration: 4000,
      meta: {
        closable: true,
        customRender: () => (
          <MangoAlert
            title={t('queueToasts.loggedOutOfQueue')}
            status={NotificationDisposition.Error}
            closeOnClick
            onClose={() => {
              toaster.dismiss(TOAST_LOGGED_OUT_ID)
            }}
          />
        ),
      },
    })
  }

  const showStatusUpdatedToast = () => {
    toaster.dismiss(TOAST_STATUS_UPDATED_ID)
    toaster.create({
      id: TOAST_STATUS_UPDATED_ID,
      duration: 4000,
      meta: {
        closable: true,
        customRender: () => (
          <MangoAlert
            title={t('queueToasts.agentStatusUpdated')}
            status={NotificationDisposition.Success}
            closeOnClick
            onClose={() => {
              toaster.dismiss(TOAST_STATUS_UPDATED_ID)
            }}
          />
        ),
      },
    })
  }

  return {
    showLoggedInToast,
    showLoggedOutToast,
    showQueueUpdateErrorModal,
    showQueueUpdateGenericErrorModal,
    showStatusUpdatedToast,
  }
}
